import React, { useState } from "react";
import { adminLogin } from "../helpers/auth";

/**
 * Full-screen admin sign-in. Just a username, a password, and a button.
 * Calls `onSuccess` once login succeeds so the app can mount the real UI.
 */
export const LoginScreen = ({ onSuccess }: { onSuccess: () => void }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (busy) return;
    setError("");
    setBusy(true);
    const res = await adminLogin(username.trim(), password);
    setBusy(false);
    if (res.ok) {
      onSuccess();
    } else {
      setError(res.error || "Invalid username or password");
    }
  };

  return (
    <div className="ib-login-screen">
      <form className="ib-login-card" onSubmit={submit} noValidate>
        <input
          id="admin-username"
          className="ib-login-input"
          type="text"
          name="username"
          autoComplete="username"
          autoFocus
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder="Username"
        />
        <input
          id="admin-password"
          className="ib-login-input"
          type="password"
          name="password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
        />
        {error ? (
          <div className="ib-login-error" role="alert">
            {error}
          </div>
        ) : null}
        <button
          type="submit"
          className="jf-btn jf-btn-primary ib-login-submit"
          disabled={busy}
        >
          {busy ? "…" : "Sign in"}
        </button>
      </form>
    </div>
  );
};

export default LoginScreen;
